/**
 * © 2024 Tandem Diabetes Care, Inc. All rights reserved.
 * Confidential Information of Tandem Diabetes Care, Inc.
 * Internal Use Only
 */

export const preLoadSegment = () => {
  const analytics = (window.analytics = window.analytics || []);
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
    'addSourceMiddleware',
    'addIntegrationMiddleware',
    'setAnonymousId',
    'addDestinationMiddleware',
  ];
  analytics.factory = function (e: any) {
    return function (...args: any[]) {
      const t = Array.prototype.slice.call(args);
      t.unshift(e);
      analytics.push(t);
      return analytics;
    };
  };
  for (let e = 0; e < analytics.methods.length; e++) {
    const t = analytics.methods[e];
    analytics[t] = analytics.factory(t);
  }
};

export const loadSegment = function (segmentId: string) {
  const analytics = (window.analytics = window.analytics || []);
  analytics.load = function (e: string, t: any) {
    const n = document.createElement('script');
    n.type = 'text/javascript';
    n.async = !0;
    n.src =
      'https://cdn.segment.com/analytics.js/v1/' + e + '/analytics.min.js';
    const a = document.getElementsByTagName('script')[0];
    if (a.parentNode === null) {
      // TODO: Investigate typescript errors coming from @tandemdiabetes/telemetry
      // log.error('LoadSegmentError', 'Parent Node is null when loading segment');
    } else {
      a.parentNode.insertBefore(n, a);
      analytics._loadOptions = t;
    }
  };
  analytics.SNIPPET_VERSION = '4.1.0';
  analytics.load(segmentId);
  analytics.page();
};
